import clsx from "clsx";
import { cloneElement, ReactElement } from "react";
import { Link, useLocation } from "react-router-dom";

import css from "./index.module.scss";

export type NavItemType =
  | {
      beta?: boolean;
      icon: ReactElement;
      label: string;
      path: string;
      type: "link";
    }
  | {
      label: string;
      type: "head";
    };

type Props = {
  item: NavItemType;
};

export const NavItem = ({ item }: Props) => {
  const { pathname } = useLocation();

  if (item.type === "head") {
    return <div className={css.head}>{item.label}</div>;
  }

  return (
    <Link
      className={clsx(
        css.navMainItem,
        pathname.startsWith(item.path) && css.active,
      )}
      key={item.label}
      to={item.path}
    >
      {cloneElement(item.icon, { className: css.navMainItemIcon })}
      <span>
        {item.label}
        {item.beta && (
          <>
            {" "}
            <small className={css.navMainItemBeta}>(BETA)</small>
          </>
        )}
      </span>
    </Link>
  );
};
